const SENTINEL_NAMES = new Set([
  '',
  '---',
  'todos',
  'ambos',
  'selecione',
  'selecione uma opção',
  'selecione uma opcao',
  'selecione uma carga',
  'selecione um destinatário',
  'selecione um destinatario'
]);

function optionLabel(option: { name?: string; label?: string }): string {
  return String(option?.name ?? option?.label ?? '').trim();
}

function isSentinelOption(option: { name?: string; label?: string; value?: unknown }): boolean {
  const label = optionLabel(option).toLowerCase();
  if (SENTINEL_NAMES.has(label)) {
    return true;
  }
  return label.startsWith('todos ') || label.startsWith('selecione ');
}

/**
 * Ordena opções de dropdown em ordem alfabética (pt-BR),
 * mantendo opções sentinela (Todos, Selecione, etc.) no topo.
 */
export function sortSelectOptions<T extends { name?: string; label?: string }>(
  options: T[] | null | undefined
): T[] {
  if (!options?.length) {
    return options ? [...options] : [];
  }

  const sentinels: T[] = [];
  const regular: T[] = [];

  for (const option of options) {
    if (isSentinelOption(option)) {
      sentinels.push(option);
    } else {
      regular.push(option);
    }
  }

  regular.sort((a, b) =>
    optionLabel(a).localeCompare(optionLabel(b), 'pt-BR', {
      sensitivity: 'base',
      numeric: true
    })
  );

  return [...sentinels, ...regular];
}
